import React from 'react'

import { useEffect, useState, useRef, useCallback } from 'react';

import ExteriorScene from'./experiences/ExteriorScene'
import InteriorScene from './experiences/InteriorScene'
import { deviceDetect, isAndroid, isBrowser, isIOS, isMobile, isMobileOnly, isWindows, isWinPhone } from 'mobile-device-detect';

import GyroscopeViewer from './components/GyroscopeViewer';
import ComingSoon from './components/ComingSoon';

const SHOW_COMING_SOON = false;

export default function App() {

  if (SHOW_COMING_SOON) {
    return <ComingSoon />;
  }

  const path = window.location.pathname;
  
  if (path.includes('/ext')) return <ExteriorScene />;
  if (path.includes('/int')) return <InteriorScene />;
  if (path.includes('/gyro')) return <GyroscopeViewer />;
  
  return (
  
  <>
      <div>
        <p>Dispositivo: {isAndroid ? "Android" : isIOS ? "iOS" : isWinPhone ? "Windows Phone" : "Desconocido"}</p>
    
      </div>
    </>
    
  )



}

